import React from "react";
import GreenStrategyPanel from "./panels/GreenStrategyPanel";
import LoadingPanel from './panels/LoadingPanel';
import ErrorPanel from './panels/ErrorPanel';
import Seo from "../components/Seo";

class GreenStrategy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                error: null,
                isload:false,
                items:[]
            }
        }
    }

    componentDidMount() {
        console.log("componentDidMount");
        fetch("/json/green_strategy.json")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    renderPanel() {
        const { error, isLoaded, items } = this.state;
        if (error) {
            console.log("error");
            return (
                <ErrorPanel data={error.message}/>
            );
        } else if (!isLoaded) {
            console.log("loading");
            return (
                <LoadingPanel />
            );
        } else {
            console.log("normal start");
            return (
                <GreenStrategyPanel data={items} />
            );
        }
    }


    render() {
        return (
            <div>
                <Seo
                    title="Joyride 綠色策略"
                    description="Joyrdie 綠色策略, 放空型策略."
                    url="https://joyride.tw/green-strategy"
                    />
                {this.renderPanel()}
            </div>
        );
    }
}

export default GreenStrategy